import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const paymentGetNextDocumentNumberAtom = createMutationAtomFactory(
  'finance.paymentGetNextDocumentNumber',
  () => ({
    financeNextPaymentDocumentNumber: true,
  }),
);
